import { inject as service } from '@ember/service';
import Route from 'cio/routes/base';
import { all } from 'rsvp';

export default class IndexRoute extends Route {
  templateName = 'base/setup/recipients/index';

  @service filters;
  @service messageSettings;
  @service store;
  @service confirmChanges;

  afterModel() {
    super.afterModel(...arguments);
    return all([
      this.store.findAll('short-segment'),
      this.filters.process.perform(),
      this.messageSettings.loadMessagingLimit.perform(),
    ]);
  }

  redirect(campaign) {
    if (!campaign.isApiTriggered) {
      this.router.transitionTo('campaigns.campaign.setup.trigger');
    }
  }

  setupController(controller, model) {
    super.setupController(...arguments);

    controller.notifyPropertyChange('segmentNames');
    controller.prepareForEdit(model);
    this.confirmChanges.register(controller, this);
  }
}
